import React from 'react';
import {
  Route as ReactDOMRoute,
  RouteProps as ReactDOMRouteProps,
  Redirect,
} from 'react-router-dom';
import { useAuth } from '../hooks/Auth';

interface RouteProps extends ReactDOMRouteProps {
  isPrivate?: boolean;
  component: React.ComponentType;
}

const Route: React.FC<RouteProps> = ({
  isPrivate = false,
  component: Component,
  ...rest
}) => {
  const { credential } = useAuth();
  return (
    <ReactDOMRoute
      {...rest}
      render={({ location }) => {
        if (isPrivate) {
          //  ----------------------------------------------se privado, olha se tem logado salvo valido
          if (Boolean(credential) === true) {
            // ---------------------------------------------se sim, vai para onde quer ir
            return <Component />;
          }
          if (Boolean(credential) === false) {
            // ---------------------------------------------se não, volta para login
            return (
              <Redirect to={{ pathname: '/', state: { from: location } }} />
            );
          }
        } // -------------------------------------------------se rota n é privada, vai para onde quiser, independentemente
        return <Component />;
      }}
    />
  );
};

export default Route;
